import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

const MUTATION = gql`
  mutation updateCustomerRole(
    $site: String!
    $customerId: String!
    $role: String!
  ) {
    updateCustomerRole(site: $site, customerId: $customerId, role: $role) {
      id
    }
  }
`;

const useUpdateCustomerRole = (onCompleted = () => {}) => {
  const [action] = useMutation(MUTATION, { onCompleted });

  return (site: string, customerId: string, role: string) => {
    return action({ variables: { site, customerId, role } });
  };
};

export default useUpdateCustomerRole;
